import styled from "styled-components";
import {flex, palette, size, text, typo} from "../../../../../../ui/styles";

export const TitleWrapper = styled.div`
  position: relative;
  top: ${size(4)};
`;
